import React from 'react';
import { Link } from 'react-router-dom';

import './NotFound.css';

const TXT = {
  title: { fr: 'Page introuvable', en: 'Page not found', de: 'Seite nicht gefunden', es: 'Página no encontrada', pt: 'Página não encontrada' },
  body: {
    fr: "La page que tu cherches n'existe pas ou a été déplacée.",
    en: "The page you're looking for doesn't exist or has been moved.",
    de: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    es: "La página que buscas no existe o ha sido movida.",
    pt: "A página que você procura não existe ou foi movida.",
  },
  home: { fr: "Retour à l'accueil", en: 'Back home', de: 'Zurück zur Startseite', es: 'Volver al inicio', pt: 'Voltar ao início' },
  gen: { fr: 'Ouvrir le générateur', en: 'Open the generator', de: 'Generator öffnen', es: 'Abrir el generador', pt: 'Abrir o gerador' },
};

function t(dict, lang) {
  return dict[lang] || dict.en || dict.fr || '';
}

const NotFound = ({ lang = 'fr' }) => {
  const base = `/${lang}`;
  return (
    <div className="notfound column">
      <div className="notfound-card column">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">{t(TXT.title, lang)}</h2>
        <p className="notfound-body">{t(TXT.body, lang)}</p>
        <div className="notfound-actions">
          <Link to={base}>
            <button type="button" className="primary alt">
              {t(TXT.home, lang)}
            </button>
          </Link>
          <Link to={`${base}/gen`}>
            <button type="button">{t(TXT.gen, lang)}</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
